export var encodeHTML = function (html) {
    var result = document
        .createElement('div')
        .appendChild(document.createTextNode(html))
        .parentNode.innerHTML.replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\'/g, '&#39;')
        .replace(/\"/g, '&#34;');
    return result;
};
export var decodeHTMLToText = function (html) {
    if (!html || typeof html !== 'string')
        return '';
    var eDiv = document.createElement('div');
    eDiv.innerHTML = html;
    var result = eDiv.innerText.replace(/(\<|\>|\'|\"|\&|\u200B)/g, '');
    return result;
};
